import Breadcrumbs from 'features/Breadcrumbs/components/Breadcrumbs';
import KioskLog from 'models/KioskLog';
import Product from 'models/Product';
import PropTypes from 'prop-types';
import React from 'react';
import { actions as categoriesActions } from 'redux/domain/Categories';
import { cancelRequest, getCancelTokenSource } from 'api/Helpers';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getCategoryTree } from 'shared/utils/categoryHelpers';
import { Link } from 'react-router-dom';
import { withTheme } from '@material-ui/core/styles';

class BreadcrumbsContainer extends React.Component {
	constructor() {
		super();

		this.cancelSource = getCancelTokenSource();
	}

	componentWillUnmount() {
		// Cancel any ongoing requests.
		cancelRequest(this.cancelSource);
	}

	/**
	 * This function returns an array containing the breadcrumbs from a category or product
	 */
	getBreadcrumbs() {
		const { currentPage, allCategories, categoryId, productCatId, product } = this.props;
		const { theme } = this.props;
		try {
			this.props.getAllCategories(this.cancelSource.token);
		} catch (error) {
			const log = new KioskLog(error, `product=${product.productId} - SKU=${product.sku}`);

			log.postMessage();
		}

		let bcInfo = [];
		let catTree = [];
		if (categoryId.length > 0) {
			// this is a category page
			catTree = getCategoryTree(categoryId, allCategories);
			bcInfo = catTree.map(cat => (
				<li key={cat.name}>
					<Link style={{ color: theme.palette.text.primary }} to={`/category/${cat.categoryId}`}>
						{cat.name}
					</Link>
				</li>
			));
		} else if (product.name !== undefined) {
			// this is a product page
			const catId = productCatId === '' ? product.parentCategoryId : productCatId;
			if (catId !== '') {
				catTree = getCategoryTree(catId, allCategories);
				bcInfo = catTree.map(cat => (
					<li key={cat.name}>
						<Link style={{ color: theme.palette.text.primary }} to={`/category/${cat.categoryId}`}>
							{cat.name}
						</Link>
					</li>
				));
				bcInfo.push(
					<li key={currentPage}>
						<Link style={{ color: theme.palette.text.primary }} to="/">
							<b>{product.name}</b>
						</Link>
					</li>,
				);
			}
		} else {
			// default to parent 0
			bcInfo.push(
				<li key={currentPage}>
					<Link style={{ color: theme.palette.text.primary }} to="/">
						<b>Categories</b>
					</Link>
				</li>,
			);
		}
		return bcInfo;
	}

	render() {
		return <Breadcrumbs crumbs={this.getBreadcrumbs()} />;
	}
}

BreadcrumbsContainer.propTypes = {
	allCategories: PropTypes.objectOf(PropTypes.object).isRequired,
	categoryId: PropTypes.string,
	currentPage: PropTypes.string.isRequired,
	getAllCategories: PropTypes.func.isRequired,
	product: PropTypes.instanceOf(Product),
	productCatId: PropTypes.string,
	theme: PropTypes.instanceOf(Object).isRequired,
};

BreadcrumbsContainer.defaultProps = {
	categoryId: '',
	product: new Product(),
	productCatId: '',
};

const mapDispatchToProps = dispatch => bindActionCreators({ ...categoriesActions }, dispatch);

const mapStateToProps = state => {
	const currentPage = state.breadcrumbs.get('currentPage');
	const allCategories = state.categories.get('allCategories');
	return {
		allCategories,
		currentPage,
	};
};

// for testing purposes
export { BreadcrumbsContainer as BreadcrumbsContainerClass, mapStateToProps, mapDispatchToProps };

// connect returns a function that accepts a component
export default connect(mapStateToProps, mapDispatchToProps)(withTheme(BreadcrumbsContainer));
